import React from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { VariableResultColumnData, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { Column16 } from '@makyoapp/makyo-icon/icon'
import { Button } from '@makyoapp/makyo-ui'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useDbDataV2 } from '@/hooks/useDbDataV2'

import { VariableColumnDd } from './VariableColumnDd'
import { VariableTable } from './VariableTable'
import { VariableWrapper } from './VariableWrapper'

export default function VariableColumnData({
  id,
  forceUserSpecific = false,
  excludeColIds = [],
  ...props
}: {
  id?: string
  forceUserSpecific?: boolean
  onChange?: (value: VariableResultColumnData) => void
  columnTypes?: ColumnTypes[]
  tableId?: string
  excludeColIds?: string[]
}) {
  const [show, setShow] = useBoolean(false)
  const [us, setUs] = useBoolean(forceUserSpecific)

  console.log({ excludeColIds })

  return (
    <VariableWrapper id={id} show={show} setShow={setShow} title={<Trans>Column Data</Trans>} icon={<Column16 />}>
      <VariableColumnDataBody
        {...props}
        value={{
          id: uuid4(),
          flag: VariableSelectFeatureFlag.ColumnData,
          tbl: undefined,
          col: undefined,
          userSpecific: false,
        }}
        setShow={setShow}
        userSpecific={us}
        setUserSpecific={setUs}
        excludeColIds={excludeColIds}
      />
    </VariableWrapper>
  )
}

export function VariableColumnDataBody({
  onChange,
  columnTypes = Object.values(ColumnTypes),
  setShow,
  value,
  userSpecific,
  noTbl = false,
  children,
  tableId,
  excludeColIds = [],
  isSingleCell = false,
}: {
  onChange?: (value: VariableResultColumnData) => void
  columnTypes?: ColumnTypes[]
  setShow: (nextShow: boolean) => void
  value: VariableResultColumnData
  userSpecific?: boolean
  setUserSpecific?: (next: boolean) => void
  noTbl?: boolean
  children?: React.ReactNode
  tableId?: string
  excludeColIds?: string[]
  isSingleCell?: boolean
}) {
  const { dbId } = useDbClientContext()
  const { activeLayerTableId } = useActiveLayerContext()

  const { tbl, setTbl, col, setCol, tblOptions, colOptions } = useDbDataV2(
    columnTypes,
    excludeColIds,
    dbId,
    value?.tbl || tableId || activeLayerTableId,
    value?.col,
    isSingleCell
  )

  const id = value.id

  const showTableSelect = isSingleCell || (!noTbl && !tableId && !activeLayerTableId)

  return (
    <div className='flex-c flex-col'>
      {showTableSelect && <VariableTable setTbl={setTbl} tbl={tbl} tblOptions={tblOptions} />}

      <VariableColumnDd setCol={setCol} col={col} colOptions={colOptions} />

      {children}

      <div className='w-full px-2'>
        <Button
          className='w-full'
          disabled={(!noTbl && !tbl) || !col}
          onClick={() => {
            onChange?.({
              id,
              flag: VariableSelectFeatureFlag.ColumnData,
              tbl,
              col,
              userSpecific: userSpecific ? userSpecific : false,
            })
            setShow(false)
          }}
        >
          <Trans>Select</Trans>
        </Button>
      </div>
    </div>
  )
}
